// Application
import { LoginType } from 'typings/auth'
import { isValidCPF } from '@brazilian-utils/brazilian-utils'

export const checkUniqueID = (value: string): LoginType => {
    if (value.length === 0) {
        return LoginType.empty
    }
    if (isValidCPF(value)) {
        return LoginType.cpf
    }
    return LoginType.cip
}
